module.exports = __webpack_public_path__ + "img/resultsCheck.2e99357e.svg";